import { personeelsdienstLabelWidth } from "@personeel/components/Werklijnen/Personeelsdiensten/PersoneelsdienstLabel/PersoneelsdientLabel.tsx";
import { DateTime } from "luxon";

const zoomDefault = 12;

export const calcPosition = (
  date: DateTime,
  timeLineBegin: DateTime,
  timeLineEnd: DateTime,
  scale: number = zoomDefault,
) => {
  const seconds = DateTime.min(date, timeLineEnd).toUnixInteger() - timeLineBegin.toUnixInteger();
  return (seconds / 60) * scale;
};

export const calcWidth = (
  begin: DateTime,
  eind: DateTime,
  timeLineEnd: DateTime<true>,
  scale?: number,
) => {
  return (
    calcPosition(eind, begin, timeLineEnd, scale) - calcPosition(begin, begin, timeLineEnd, scale)
  );
};

export const calcCurrentTime = (
  scrollLeft: number,
  clientWidth: number,
  timeLineBegin: DateTime<true>,
  scale: number = zoomDefault,
): DateTime<true> => {
  const windowPosRelative = scrollLeft + clientWidth / 2 - personeelsdienstLabelWidth;

  const minutesFromStart = windowPosRelative / scale;
  const time = timeLineBegin.plus({
    minutes: Number.isNaN(minutesFromStart) ? 0 : minutesFromStart,
  });

  return time;
};
